import {
  HouseMedicalCircleExclamationRegular,
  ArrowLeftRegularIcon,
} from "@elixir/icons";
import { PrimaryButton } from "ui";
import useHprHfrOnboardingStore from "../../../stores/hpr-hfr-dhis-onboarding";
import useGetMyProfile from "../../../apis/axon/get-my-profile";
import { navigate } from "../../../utils/bridges/methods";

export default function HprHfrFlowPitchCard({
  clinicId,
}: {
  clinicId: string;
}) {
  const clearHprHfrStore = useHprHfrOnboardingStore(
    (state) => state.clearHprHfrStore
  );
  const setOpenModal = useHprHfrOnboardingStore((state) => state.setOpenModal);
  const setClinicId = useHprHfrOnboardingStore((state) => state.setClinicId);

  const { data: doctorProfile } = useGetMyProfile();

  if (!doctorProfile) {
    return null;
  }

  return (
    <div className="dr-flex dr-flex-col dr-space-y-16 dr-p-8 dr-max-w-204">
      <div className="dr-flex dr-space-x-8 dr-items-center dr-p-8 dr-rounded-8 dr-bg-darwin-touch-yellow-bg-light">
        <HouseMedicalCircleExclamationRegular className="dr-text-doctor-darwin-accent-bright-yellow-800 dr-w-16 dr-h-16" />
        <p className="dr-text-darwin-touch-yellow-dark">
          HFR Creation Pending!
        </p>
      </div>
      <div className="dr-flex dr-items-center dr-space-x-4">
        <img
          alt="dhis"
          src="https://cdn.eka.care/vagus/clr7tg7jk00010tgfak6fa9y6.png"
          className="dr-w-36 dr-h-36"
          height={"36"}
          width={"36"}
        />
        <div className="dr-flex dr-flex-col">
          <p className="HeadlineExtraBold">Earn with Eka:</p>
          <p className="BodyBold">
            An <span className="dr-text-darwin-touch-green-primary">ABDM</span>{" "}
            Initiative
          </p>
        </div>
      </div>
      <p className="CalloutBold dr-text-darwin-touch-neutral-800">
        Enrol into DHIS and start receiving incentive of ₹20 per record linked
      </p>
      <PrimaryButton
        title="Register Now"
        onClick={(e) => {
          e.stopPropagation();
          clearHprHfrStore();
          setClinicId(clinicId);

          if (doctorProfile) {
            const {
              profile: {
                professional: { clinics = [] },
              },
            } = doctorProfile;

            const clinicsWithHfr = clinics.filter((item) => !!item.hfr_id);

            if (clinicsWithHfr.length) {
              setOpenModal(true);
            } else {
              navigate("push", "/app/abha-dashboard");
            }
          } else {
            setOpenModal(true);
          }
        }}
        buttonIconPosition="right"
        IconComponent={ArrowRight}
      />
    </div>
  );
}

function ArrowRight() {
  return (
    <ArrowLeftRegularIcon className="dr-rotate-180 dr-text-darwin-touch-neutral-0 dr-w-12 dr-h-12" />
  );
}
